import React from "react";
import classnames from "classnames";
import { Checkbox } from "@my-scoot/component-library-legacy";
import constants from "constants/constants";
import { OfferingNameChips } from "features/PaymentLinks/modules/ExistingPaymentLinks/components/OfferingNameChip/OfferingNameChip";

const getStatus = (link) => {
  if (!link?.expiry_date)
    return { label: "Active", background: "tw-bg-[#00B779]" };

  const expired = new Date(link.expiry_date) < new Date();
  return expired
    ? { label: "Expired", background: "tw-bg-[#BF2600]" }
    : { label: "Scheduled", background: "tw-bg-[#E3963E]" };
};

export const ComboPageOption = ({
  option,
  isSelected,
  isLast,
  lastElementRef,
  onChange,
  showCheckbox,
  showStatus,
  className = "",
}) => {
  const { label, background } = getStatus(option || {});
  return (
    <div
      id={option.dynamic_link_id}
      className={classnames(
        // layout + divider
        "tw-flex tw-justify-between tw-items-center tw-gap-[12px] tw-cursor-pointer tw-border-0 tw-border-solid tw-border-b tw-border-[#D3D3D3] last:tw-border-b-0",
        // selected state
        { "tw-bg-[#F5FAFF]": isSelected },
        className || "tw-py-3 tw-px-[16px]"
      )}
      onClick={() => onChange(option?.value)}
      {...(isLast ? { ref: lastElementRef } : {})}
    >
      {/* LEFT SECTION */}
      <div className="tw-flex tw-items-center tw-gap-4 tw-flex-grow ">
        {showCheckbox && (
          <div className="tw-min-w-3">
            <Checkbox checked={isSelected} tabIndex={-1} size="large" />
          </div>
        )}

        {/* TEXT DETAILS */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          <div className="tw-text-[14px] tw-leading-[17px] tw-break-words">
            {option?.title}
          </div>

          <div className="tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-2">
            <p className="tw-text-sm tw-leading-tight tw-text-[#666]">
              {`${constants.CURRENCY_SYMBOL_MAP[option.currency]} ${
                option?.link_price ?? "N/A"
              } | `}
            </p>

            <div className="tw-flex tw-flex-wrap tw-min-w-0">
              <OfferingNameChips
                listingNames={(option?.pop_name || "").split(", ")}
                className="!tw-text-xs"
                parentClassName="!tw-py-0"
              />
            </div>
          </div>
        </div>
      </div>

      {/* STATUS */}
      {showStatus && label && (
        <div
          className={classnames(
            "tw-text-white tw-text-[14px] tw-leading-[22px] tw-rounded-[5px] tw-px-[8px] tw-whitespace-nowrap",
            background
          )}
        >
          {label}
        </div>
      )}
    </div>
  );
};
